export default __webpack_public_path__ + "static/media/cancelled_icon.833b86fc.svg";